<template>
  <div class="container" style="width:97%;height:95%; overflow:hidden;">
    <div class="filter-container">
      查询条件：
<!--      <el-date-picker-->
<!--          v-model="value1"-->
<!--          type="daterange"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          @change="filterPaymentRecords"-->
<!--      >-->
<!--      </el-date-picker>-->
      <el-config-provider :locale="zhCn">
      <el-date-picker
          v-model="listQuery.DTStartCreatedDate"
          type="date"
          placeholder="开始日期"
          clearable
          :locale="zhCn"
      />
       至
      <el-date-picker
          v-model="listQuery.DTEndCreatedDate"
          type="date"
          placeholder="结束日期"
          style="margin-left: 10px;"
          clearable
          :locale="zhCn"
      />
      </el-config-provider>
      <el-input style="width: 200px;margin-left: 10px;" placeholder="请输入项目负责人" v-model="queryKey" clearable
                @keydown.enter.prevent="query"/>
      <el-button icon="el-icon-search" type="success" style="margin-bottom: 10px;margin-left: 10px;" size="small"
                 @click="query">查询
      </el-button>
      <el-button class="filter-item" type="primary" size="small" icon="el-icon-refresh"
                 style="margin-bottom: 10px;margin-left: 5px;" @click="resetSearch">重 置
      </el-button>
      <el-button v-if="!downloadLoading" class="filter-item" type="success" size="small" icon="el-icon-download"
                 style="margin-bottom: 10px;margin-left: 5px;" @click="exportData">导出
      </el-button>
      <el-button v-if="downloadLoading" :loading="downloadLoading" class="filter-item" type="success" size="small"
                 icon="el-icon-download" style="margin-bottom: 10px;margin-left: 5px;">正在导出
      </el-button>
      <el-button icon="el-icon-s-check" type="danger" style="margin-bottom: 10px;margin-left: 10px;" size="small"
                 @click="accounting">核算
      </el-button>
    </div>

    <div style="display: flex; justify-content: space-between; margin-top: 20px;">
      <!-- 收款记录区域 -->
      <div style="width: 48%; overflow-y: auto;">
        <div style="margin-bottom: 5px;">收款记录：</div>
        <el-table
            v-loading="listLoading"
            :data="receptionRecordList"
            border
            fit
            highlight-current-row
            style="width: 100%;"
            class="custom-table"
            :height=tableHeight
            ref="receptionTable"
        >
          <!-- 表格列定义 -->
          <el-table-column label="类型" align="center" width="130px">
            <template v-slot="{row}">
              {{ row.type === 1 ? '收款' : '总计' }}
            </template>
          </el-table-column>
          <el-table-column label="金额" align="center">
            <template v-slot="{row}">
              <span>{{ row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="项目负责人" align="center">
            <template v-slot="{row}">
              <span>{{ row.paymentLeader }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付时间" align="center">
            <template v-slot="{row}">
              <span>{{ formatDate(row.payTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" align="center">
            <template v-slot="{row}">
              <span>{{ formatDate(row.updated_at) }}</span>
            </template>
          </el-table-column>
<!--          <el-table-column label="凭证" align="center">-->
<!--            <template v-slot="{row}">-->
<!--              <el-button v-if="row.proof && row.proof !== 'null'" type="text" @click="viewProof(row.proof)">-->
<!--                查看凭证-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>

      <!-- 付款记录区域 -->
      <div style="width: 48%;  overflow-y: auto;">
        <div style="margin-bottom: 5px;">付款记录：</div>
        <el-table
            v-loading="listLoading"
            :data="paymentRecordList"
            border
            fit
            highlight-current-row
            style="width: 100%;"
            class="custom-table"
            :height=tableHeight
            ref="paymentTable"
        >
          <!-- 表格列定义 -->
          <el-table-column label="类型" align="center" width="130px">
            <template v-slot="{row}">
              {{ row.type === 2 ? '付款' : '总计' }}
            </template>
          </el-table-column>
          <el-table-column label="金额" align="center">
            <template v-slot="{row}">
              <span>{{ row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="项目负责人" align="center">
            <template v-slot="{row}">
              <span>{{ row.paymentLeader }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收款人" align="center">
            <template v-slot="{row}">
              <span>{{ row.person === "null" ? '————' : row.person }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付时间" align="center">
            <template v-slot="{row}">
              <span>{{ formatDate(row.payTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" align="center">
            <template v-slot="{row}">
              <span>{{ formatDate(row.updated_at) }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>
  </div>
</template>


<script>
import $ from "jquery";
import global from "@/utils/global";
import md5 from "js-md5";
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
// import zhCn from "element-plus/packages/locale/lang/zh-cn";

export default {
  name: "ItemStatistics",
  computed: {
    zhCn() {
      return zhCn
    }
  },
  data() {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1); // 今年的1月1日
    return {
      tableHeight: 1000, // 初始默认高度，可根据实际情况调整
      Type:{
        pay:2,
        rec:1
      },
      queryKey:'',
      back:[],
      filteredPaymentRecordList: [], // 筛选后的数据
      value1: [startOfYear, now],
      paymentRecordList:[],
      receptionRecordList:[],
      statistics:[],
      //判斷是否是添加按鈕從而走不同的方法
      dialogImageUrl: '',
      dialogVisible: false,
      dialogVisitVisible: false,
      list: [],
      total: 0,
      listLoading: false,
      downloadLoading: false,
      listQuery: {
        "pageCount": 1000,
        "pageNum": 1,
        keywords: '',
        keyName: '',
        DTStartCreatedDate: startOfYear,
        DTEndCreatedDate: now,
        "search": {}
      },
      saleItem: {
        "productCount": '',
        "productName": "",
        "productPrice": ""
      },
      formModel: {
        "contractPrice": "",
        "contracts": [],
        "customerName": "",
        "inputReceipts": [],
        "outReceipts": [],
        "paidPrice": "",
        "needReceivedPrice": "",
        "needPaidPrice": "",
        "projectLeader": "",
        "projectName": "",
        "receivedPrice": "",
        "saleItems": []
      },

    }
  },
   created() {
    this.paymentRecord();
    this.receptionRecord();
    this.handleResize()
  },
  watch: {
  },
  mounted() {
    // 添加窗口大小变化的监听器
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      // 更新窗口高度
      if(window.innerHeight<750) {
        this.tableHeight = `${window.innerHeight/2.5}px`
      }
      else {
        this.tableHeight = `${window.innerHeight/1.3 }px`
      }
      this.$nextTick(() => {
        this.$refs.receptionTable.doLayout();
        this.$refs.paymentTable.doLayout();
      });
    },
    //TODO 核算
    accounting()
    {
      const [start, end] = this.value1;
      // 使用本地时间格式化日期
      const formatLocalDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
      };
      const startDate = formatLocalDate(start);
      const endDate = formatLocalDate(end);
      const messageContent = `确认核算 <h style="color: teal;">${startDate}</h> 至 <h style="color: teal;">${endDate}</h> 的数据吗？核算后数据将无法修改！`;
      this.$confirm(messageContent, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true // 允许 HTML 字符串
      }).then(() => {
        this.reqAccounting()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消核算'
        });
      });
    },

    reqAccounting()
    {
      // if(!(this.paymentRecordList.every(item => item.isAccounting === true) && this.receptionRecordList.every(item => item.isAccounting === true)) )
      // {
      //   return;
      // }
      const [start, end] = this.value1;
      const startDate = new Date(start).toISOString();
      const endDate = new Date(end).toISOString();
      const requestData = {
        search: {
          DTStartCreatedDate: startDate,
          DTEndCreatedDate: endDate,
        }
      };
      this.$axios({
        url: this.localpath + 'saleproject/accountingPayRecord',
        method: 'post',
        data: JSON.stringify(requestData),
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: res.data.msg + '!',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },


    // getProjectName(projectId) {
    //   const project = this.list.find(item => item.strID === projectId);
    //   return project ? project.projectName : projectId;
    // },
    query()
    {
      if(this.value1 === null || this.value1 ===undefined)
      {
        this.$message({
          message: '请选择时间范围',
          type: 'error'
        })
        return;
      }
      console.log("查询条件:"+this.queryKey);
      this.searchList(this.queryKey,this.Type.rec)
      this.searchList(this.queryKey,this.Type.pay)
    },
    filterPaymentRecords() {
        // this.searchList(this.queryKey,this.Type.rec);
        // this.searchList(this.queryKey,this.Type.pay);
        // this.calculateStatistics()
    },
    calculateStatistics() {
      const stats = []; // 存储统计结果
      [1, 2].forEach(type => {
        const totalAmount = this.paymentRecordList
            .filter(item => item.type === type) // 筛选当前类型
            .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0); // 累加金额
        stats.push({
          type: type,
          typeLabel: type === 1 ? '总收款' : '总付款',
          totalAmount: totalAmount,
        });
      });
      let record = this.paymentRecordList.find(item => item.id === '000000000000000000000000');
      let totalPrice = record ? record.TotalPrice : null; // 确保记录存在，如果存在则取出 TotalPrice，否则返回 null
      stats.push({
        type: 3,
        typeLabel: '总计',
        totalAmount: totalPrice,
      });
      this.statistics = stats; // 更新统计结果
    },

    viewProof(proofUrl) {
      // 如果 proofUrl 不是完整 URL，通过 getImgUrl 方法获取完整的图片链接
      let fileUrl = this.getImgUrl(proofUrl);
      // console.log('文件地址: ' + fileUrl);
      // 打开新窗口，并写入 HTML 显示图片
      const newWindow = window.open("", "_blank");
      newWindow.document.write(`
    <html>
      <head>
        <title>图片预览</title>
        <style>
          body {
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #000;
          }
          img {
            max-width: 100%;
            max-height: 100vh;
            width: auto;    /* 图片宽度占页面80% */
            height: auto;
          }
        </style>
      </head>
      <body>
        <img src="${fileUrl}" alt="图片预览" />
      </body>
    </html>
  `);
      newWindow.document.close();
    },
    getImgUrl(url) {
      var str = {}
      var time = Date.parse(new Date()) / 1000;
      $.ajax({
        url: global.syOssUrl + '/o2u?objName=' + url, // 后面改为全局变量
        type: 'get',
        async: false, // 同步请求
        headers: {
          'timestamp': time,
          'sign': md5('6486b66b41f8df68777eac23' + time)
        },
        data: {},
        timeout: 10000,
        dataType: 'json',
        success: function (response) {
          str = response.msg
        },
      });
      return str
    },
    formatDate(dateStr) {
      if(dateStr === null || dateStr === '') {
        return ''
      }
      const date = new Date(dateStr)
      const pad = (n) => (n < 10 ? '0' + n : n)
      const year = date.getFullYear()
      const month = pad(date.getMonth() + 1)
      const day = pad(date.getDate())
      return `${year}-${month}-${day}`
    },
    //收款
    receptionRecord()
    {
      // const [start, end] = this.value1;
      // const startDate = new Date(start).toISOString();
      // const endDate = new Date(end).toISOString();
      const startDate = this.listQuery.DTStartCreatedDate;
      const endDate = this.listQuery.DTEndCreatedDate;
      console.log(startDate, endDate);
      const requestData = {
        pageCount: 1000,
        pageNum: 1,
        search: {
          Type:this.Type.rec,
          DTStartCreatedDate: startDate,
          DTEndCreatedDate: endDate,
        }
      };
      this.$axios({
        url: this.localpath + 'saleproject/payRecordStatistics',
        method: 'post',
        data: JSON.stringify(requestData),
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.code === 0) {
          console.log('获取收付款记录成功');
          this.receptionRecordList = res.data.msg.list
          const record = this.receptionRecordList.find(
              (item) => item.id === "000000000000000000000000"
          );
          if (record) {
            // 修改该记录的属性值
            record.type = "总计";
            record.amount = record.TotalPrice || 0; // 假设 `TotalPrice` 是返回的总金额
            record.payTime = '';
            record.updated_at = '';
            record.created_at = '';
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    //付款
    paymentRecord()
    {
      // const [start, end] = this.value1;
      // const startDate = new Date(start).toISOString();
      // const endDate = new Date(end).toISOString();
      const startDate = this.listQuery.DTStartCreatedDate;
      const endDate = this.listQuery.DTEndCreatedDate;
      console.log(startDate, endDate);
      const requestData = {
        pageCount: 1000,
        pageNum: 1,
        search: {
          Type:this.Type.pay,
          DTStartCreatedDate: startDate,
          DTEndCreatedDate: endDate,
        }
      };
      this.$axios({
        url: this.localpath + 'saleproject/payRecordStatistics',
        method: 'post',
        data: JSON.stringify(requestData),
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.code === 0) {
          console.log('获取收付款记录成功');
          this.paymentRecordList = res.data.msg.list

          const record = this.paymentRecordList.find(
              (item) => item.id === "000000000000000000000000"
          );
          if (record) {
            // 修改该记录的属性值
            record.type = "总计";
            record.amount = record.TotalPrice || 0; // 假设 `TotalPrice` 是返回的总金额
            record.payTime = '';
            record.updated_at = '';
            record.created_at = '';
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },

    searchList(leader,condition)
    {
      // const [start, end] = this.value1;
      // const startDate = new Date(start).toISOString();
      // const endDate = new Date(end).toISOString();
      const startDate = this.listQuery.DTStartCreatedDate;
      const endDate = this.listQuery.DTEndCreatedDate;
      console.log(startDate, endDate);
      let requestData = {
        pageCount: 1000,
        pageNum: 1,
        search: {
          Type:condition,
          DTStartCreatedDate: startDate,
          DTEndCreatedDate: endDate,
        }
      };
      if (leader) {
        requestData.search.PaymentLeader = leader;
      }
      this.$axios({
        url: this.localpath + 'saleproject/payRecordStatistics',
        method: 'post',
        data: JSON.stringify(requestData),
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.code === 0) {
          console.log('获取收付款记录成功');
          if(condition === 2) {
            this.paymentRecordList = res.data.msg.list
            const record = this.paymentRecordList.find(
                (item) => item.id === "000000000000000000000000"
            );
            if (record) {
              // 修改该记录的属性值
              record.type = "总计";
              record.amount = record.TotalPrice || 0; // 假设 `TotalPrice` 是返回的总金额
              record.payTime = '';
              record.updated_at = '';
              record.created_at = '';
            }
          }else {
            this.receptionRecordList = res.data.msg.list
            const record = this.receptionRecordList.find(
                (item) => item.id === "000000000000000000000000"
            );
            if (record) {
              // 修改该记录的属性值
              record.type = "总计";
              record.amount = record.TotalPrice || 0; // 假设 `TotalPrice` 是返回的总金额
              record.payTime = '';
              record.updated_at = '';
              record.created_at = '';
            }
          }
        } else {
          if(condition === this.Type.pay) {
            // this.$message({
            //   message: '未查找到付款数据',
            //   type: 'error'
            // })
            this.paymentRecordList = []
          }else {
            // this.$message({
            //   message: '未查找到收款数据',
            //   type: 'error'
            // })
            this.receptionRecordList = []
          }
          //如果没有查到数据就要把筛选条件还原
          const now = new Date();
          const startOfYear = new Date(now.getFullYear(), 0, 1); // 今年的1月1日
          this.value1 = [startOfYear, now];
          this.queryKey = ''
        }
      })
    },



    resetSearch() {
      const now = new Date();
      const startOfYear = new Date(now.getFullYear(), 0, 1); // 今年的1月1日
      // this.value1 = [startOfYear, now];
      this.listQuery.DTStartCreatedDate = startOfYear;
      this.listQuery.DTEndCreatedDate = now;
      this.queryKey = ''
      this.listQuery.keyName = ''
      this.paymentRecord();
      this.receptionRecord();
    },
    exportData() {
      // 取日期范围，并转换为 ISO 8601 格式
      // const [start, end] = this.value1;
      // const startDate = new Date(start).toISOString();
      // const endDate = new Date(end).toISOString();
      const startDate = this.listQuery.DTStartCreatedDate;
      const endDate = this.listQuery.DTEndCreatedDate;
      console.log(startDate, endDate);

      // 构造请求数据
      const requestData = {
        pageCount: 1000,
        pageNum: 1,
        search: {
          DTStartCreatedDate: startDate,
          DTEndCreatedDate: endDate
        }
      };
      if (this.queryKey) {
        requestData.search.PaymentLeader = this.queryKey;
      }
      // 发起请求，注意 responseType 设置为 blob
      this.$axios({
        url: this.localpath + 'saleproject/exportPayRecordStatistics',
        method: 'post',
        data: JSON.stringify(requestData),
        responseType: 'blob', // 返回数据类型为二进制流
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        // 创建 Blob 对象，注意文件类型根据实际情况调整
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // 生成下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `收付款记录_${new Date().toISOString().slice(0,10)}.xlsx`;
        document.body.appendChild(a);
        a.click();
        // 下载后释放 URL 对象
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
      }).catch(error => {
        console.error("导出失败：", error);
        this.$message({
          message: '导出失败',
          type: 'error'
        });
      });
    },

  },


}
</script>

<style scoped>
#upload {
  margin-left: 20px;
  margin-top: 15px;
}

#upload :deep() .el-upload--text {
  border: 0px dashed #d9d9d9 !important;
  width: 230px;
  height: 55px;
}

.uploadpdf {
  margin-left: 20px;
  /*margin-top: 15px;*/
}

.uploadpdf :deep() .el-upload--text {
  border: 0px dashed #d9d9d9 !important;
  width: 230px;
  height: 0;
}

.uploadpdf :deep() .el-icon-close {
  display: none;
}

.uploadpdf :deep() .el-icon-close-tip {
  display: none;
}

#uploadVisitjinxiang:deep() .el-upload {
  display: none;
}

#uploadVisitjinxiang:deep() .el-upload-list__item-delete {
  display: none;
}

#uploadVisitxiaoxiang:deep() .el-upload {
  display: none;
}

#uploadVisitxiaoxiang:deep() .el-upload-list__item-delete {
  display: none;
}

#upload :deep() .el-upload {
  text-align: left;
}

/* 如果使用 scoped 样式，需要使用 ::v-deep 或 /deep/ */
::v-deep .row-green td {
  color: green !important;
}

::v-deep .row-red td {
  color: red !important;
}

::v-deep .el-table__footer-wrapper {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: #fff; /* 根据需要设置背景颜色 */
}




</style>

